import { render, staticRenderFns } from "./EditReportingCentre.vue?vue&type=template&id=4bf37ec4&"
import script from "./EditReportingCentre.vue?vue&type=script&lang=ts&"
export * from "./EditReportingCentre.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports